module.exports = __webpack_public_path__ + "static/media/Mereoleona-Script-Alt.e102bce0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Mereoleona-Script-Alt.woff2
// module id = 3047
// module chunks = 51